"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TpdAgencyService = void 0;
const nodejs_library_1 = require("@tpd-web-common-libs/nodejs-library");
const constants_1 = require("../common/constants");
const request_1 = require("../common/request");
class TpdAgencyService {
    constructor() {
        this.commonNetworkService = new nodejs_library_1.CommonNetworkService();
    }
    isSuperUser() {
        return __awaiter(this, void 0, void 0, function* () {
            let isSuperUser = false;
            // verifico se sono o meno superUser
            const localData5Storage = yield nodejs_library_1.Helpers.SessionHelper.getData(constants_1.Constants.lsMapObject._data5).catch((e) => console.error("Errore nel recupero di dati 5", e));
            if (localData5Storage) {
                const jsonObject = JSON.parse(localData5Storage);
                // tslint:disable-next-line: triple-equals
                if (jsonObject.value0 == "0") {
                    isSuperUser = true;
                }
            }
            return isSuperUser;
        });
    }
    getElencoAgenzie() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                // const valueData5 = await Helpers.SessionHelper.getData(
                //     Constants.lsMapObject._data5
                // );
                // let isSuperUser = false;
                // // verifico se sono o meno superUser
                // if (valueData5) {
                //     const jsonObject = JSON.parse(valueData5);
                //     // tslint:disable-next-line: triple-equals
                //     if (jsonObject.value0 == "0") {
                //         isSuperUser = true;
                //     }
                // }
                const isSuperUser = yield this.isSuperUser();
                const su = isSuperUser ? "su/" : "";
                if (constants_1.Constants.usoNuovaUCC) {
                    return new Promise((resolve, reject) => {
                        const request = new request_1.Request(`contesto-utente/v2/me/${su}agenzie`, {}, false, false, "url_priv");
                        this.commonNetworkService
                            .get(request.completeUrl, request.headers)
                            .then((responseAgenzieNuovaUCC) => {
                            resolve(this.buildAgenciesResponse(responseAgenzieNuovaUCC));
                        })
                            .catch((err) => {
                            reject(err);
                        });
                    });
                }
                else {
                    const request = new request_1.Request(`contesto-utente/v1/me/${su}agenzie`, {}, false, false, "url_priv");
                    return this.commonNetworkService.get(request.completeUrl, request.headers);
                }
            }
            catch (e) {
                console.error("Errore in fase di recupero dati dallo storage: ", e);
                return Promise.reject(e);
            }
        });
    }
    buildAgenciesResponse(response) {
        const agenzieObjOldVersion = response.agenzie.map((item) => {
            let phoneNumber = "";
            let faxNumber = "";
            let email = "";
            if (item.recapitiAgenzia)
                for (const recapito of item.recapitiAgenzia) {
                    if (recapito.tipo === 1) {
                        phoneNumber = recapito.valore;
                    }
                    if (recapito.tipo === 2) {
                        faxNumber = recapito.valore;
                    }
                    if (recapito.tipo === 4) {
                        email = recapito.valore;
                    }
                }
            const obj = {
                code: item.codice ? item.codice : "",
                exdivision: item.exdivisione ? item.exdivisione : "",
                description: item.descrizione ? item.descrizione : "",
                company: item.compagnia ? item.compagnia : "",
                address: {
                    province: item.indirizzo && item.indirizzo.provincia
                        ? item.indirizzo.provincia
                        : "",
                    addressId: item.indirizzo && item.indirizzo.indirizzoId
                        ? item.indirizzo.indirizzoId
                        : "",
                    addressType: item.indirizzo && item.indirizzo.tipoIndirizzo
                        ? item.indirizzo.tipoIndirizzo
                        : "",
                    cap: item.indirizzo && item.indirizzo.cap ? item.indirizzo.cap : "",
                    district: item.indirizzo && item.indirizzo.citta ? item.indirizzo.citta : "",
                    address: item.indirizzo && item.indirizzo.indirizzo
                        ? item.indirizzo.indirizzo
                        : "",
                    openingTime: item.indirizzo && item.indirizzo.orarioApertura
                        ? item.indirizzo.orarioApertura
                        : "",
                    latitude: item.indirizzo && item.indirizzo.latitudine
                        ? parseFloat(item.indirizzo.latitudine)
                        : 0,
                    longitude: item.indirizzo && item.indirizzo.longitudine
                        ? parseFloat(item.indirizzo.longitudine)
                        : 0,
                    management: item.indirizzo && item.indirizzo.gestione
                        ? item.indirizzo.gestione
                        : "",
                    phoneNumber: phoneNumber,
                    faxNumber: faxNumber,
                    email: email,
                    name: item.indirizzo && item.indirizzo.nome ? item.indirizzo.nome : "",
                },
                division: item.comparto ? item.comparto.toString() : "",
                familyId: item.famigliaId ? item.famigliaId.toString() : "",
                itemType: "",
                type: item.tipo ? item.tipo : 0,
                product: item.descrizioneProdotto ? item.descrizioneProdotto : "",
                codTipoUv: item.codTipoUv,
            };
            return obj;
        });
        return {
            agencies: agenzieObjOldVersion,
        };
    }
}
exports.TpdAgencyService = TpdAgencyService;
